export { useIdentityVariantFields } from './identity-variant-attribute-rows';
export type { UseIdentityVariantFieldsOptions } from './identity-variant-attribute-rows';
export { OtherNamesSubsection } from './other-names-subsection';
export { OtherAddressesSubsection } from './other-addresses-subsection';
export { IdentityVariantRow } from './identity-variant-row';
export { VariantSubsection } from './variant-subsection';
export { VariantInlineEditor } from './variant-inline-editor';
export { VariantProvenanceFootnote } from './variant-provenance-footnote';
export { NameVariantForm } from './name-variant-form';
export { AddressVariantForm } from './address-variant-form';
